import styles from './testPlanHeaderScenarioItem.module.scss';
import { useSelector } from "react-redux";
import { RootState } from "../../../../store";
import infoIcon from "../../../../shared/images/info.svg";
import { TestPlanScenario } from "../../../../types/testPlanTypes";
import { TestCaseTemplate } from "../../../../types/testCaseTemplateTypes";
import { Accordion } from "../../../../shared/components/accordion/accordion";
import arrowIcon from "../../../../shared/images/arrow.svg";
import {
  memo,
  useMemo
} from "react";
import { TestPlanHeaderTestCaseItem } from "../testPlanHeaderTestCaseItem/testPlanHeaderTestCaseItem";

type TestPlanHeaderScenarioProps = {
  scenario: TestPlanScenario;
  testCaseTemplates?: Array<TestCaseTemplate>;
  onClickRerun: () => void;
}

export const TestPlanHeaderScenarioItem = memo(({ scenario, testCaseTemplates, onClickRerun }: TestPlanHeaderScenarioProps) => {
  const selectedTestCase = useSelector((state: RootState) => state.testCaseTemplateSlice.selectedTestCase);

  const isSelected = useMemo(() => {
    return scenario.assignedRequests.some(request => selectedTestCase.internalId === `${scenario.internalId}-${request.id}`);
  }, [selectedTestCase, scenario]);

  return (
    <div className={styles.container}>
      <Accordion
        activeClassName={styles.active}
        activeIndex={0}
        disabledAutoScroll
        data={[{
          title: (
            <div className={styles.accordionTitle}>
              <div className={`${styles.info} ${isSelected ? styles.selected : ""}`}>
                <img src={arrowIcon} alt=""
                     className={styles.arrow}/>
                <span title={scenario.name}>{scenario.name}</span>
                {!!scenario.description && (<img className={styles.descriptionIcon} src={infoIcon} title={scenario.description} alt=""/>)}
              </div>
            </div>
          ),
          child: (
            <div className={styles.accordionItems}>
              { scenario.testCases.map(testCase =>
                <TestPlanHeaderTestCaseItem testCase={testCase}
                                            key={testCase.internalId}
                                            onClickRerun={onClickRerun}
                                            testCaseTemplates={testCaseTemplates} />)}
            </div>
          )
        }]}/>
    </div>

  );
})
